// extracted by mini-css-extract-plugin
export var methodIcon = "MethodIcon-module--methodIcon--aae22";